<template>
    <div
        class="z-checkbox"
        :class="[
            `z-checkbox--size-${size}`,
            {
                'is-required': required,
                'is-errored': error,
                'is-disabled': data.disabled
            }
        ]"
        v-if="data"
    >
        <label class="z-checkbox__label">
            <input
                class="z-checkbox__input"
                type="checkbox"
                v-model="value"
                @change="onChange"
                :value="data.id"
                :key="value"
            >
            <div class="z-checkbox__box"></div>
            <div class="z-checkbox__text">
                <vue-raw :raw="data.text" />
            </div>
        </label>
        <span
            :class="['z-checkbox__error', errorClass]"
            v-if="error"
            v-html="error"
        ></span>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import {localize} from '@/utils/i18n'

const props = defineProps({
    required: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'm',
        validator: prop => ['s', 'm', 'l'].includes(prop)
    },
    data: {
        type: Object
    },
    modelValue: {
        type: Boolean,
        default: undefined
    },
    errorClass: {
        type: String
    }
})

// emits
const emit = defineEmits([
    'update:modelValue',
    'change'
])

// static data
const errorText = localize({
    ru: 'Поле обязательно для заполнения',
    en: 'Required field',
    cn: '必填项'
})

// refs
let error = ref('')
let localValue = ref(false)

//computed
let value = computed({
    get() {
        if (props.modelValue !== undefined) return props.modelValue
        return localValue.value
    },
    set(value) {
        localValue.value = value
        emit('update:modelValue', value)
    }
})

//events
const onChange = () => {
    validate()
    emit('change', value.value)
}

// methods
const validate = () => {
    if (props.required) {
        if (!value.value) {
            error.value = errorText
            return
        }
    }
    error.value = ''
}

onMounted(() => {
    if (props.data.selected) localValue.value = true
})

defineExpose({
    validate,
    error
})
</script>

<style lang="scss" src="./index.scss"></style>
